import { log } from '@intigral/utils';
import { Component } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { appConfig } from '../config/app.config';

class ComponentErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        if (appConfig?.dataDogRUM?.isEnabled) {
            datadogRum.addError(error, {
                componentStack: errorInfo?.componentStack,
                source: 'react_component_error_boundary',
            });
        }
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return null;
        }

        return this.props.children;
    }
}

export default ComponentErrorBoundary;
